import React from "react";
import { Checkbox } from "../Input";
import donorsQuery from "../../utils/queries/donorsQuery";
import { onResetFilters } from "../../actions/Filters";
import { Loading } from "../Loader";
import { CardHeader } from "../Header";
import { connect } from "react-redux";
import handleSearch from "../../utils/handleSearch";

let copyData = [];

class DonorsFilter extends React.Component {
  state = {
    isLoading: true,
    data: [],
    page: 1,
    limit: 10,
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  componentDidUpdate(prevProps) {
    if (this.props.serviceType !== prevProps.serviceType) {
      this.dispatch(onResetFilters("donors"));
      this.getData(true);
    }
  }

  getData = async (isLoading) => {
    try {
      const { defaultLanguage } = this.props;
      const { page, limit } = this.state;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await donorsQuery(defaultLanguage, {
        page,
        limit,
      });

      this.setState({
        data: data,
        isLoading: false,
        count,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onCheck(el) {
    let { filters } = this.props;
    let { donors = [] } = filters;

    const index = donors.findIndex((sEl) => sEl.value === el._id);

    if (index === -1) {
      donors.push({
        value: el._id,
        label: el.name,
      });
    } else {
      donors.splice(index, 1);
    }

    // this.props.dispatch(
    //   onAddFilter({
    //     donors,
    //   })
    // );
    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { donors });
  }

  renderHeader() {
    return (
      <>
        <CardHeader
          isSearch
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e?.target?.value })
          }
          styles={{ height: 0 }}
          reset={
            this.props?.filters?.donors &&
            this.props?.filters?.donors?.length > 0
          }
          handleResetFilter={() =>
            this.props.dispatch(onResetFilters("donors"))
          }
        />
      </>
    );
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        <div className="dropdown-content">
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : (
            this.state?.data?.map((el, i) => {
              return (
                <Checkbox
                  label={el.name}
                  key={i}
                  onCheck={() => this.onCheck(el)}
                  checked={this.props?.filters?.donors?.find(
                    (sEl) => sEl.value === el._id
                  )}
                />
              );
            })
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  const { filters } = state.Filters;
  return {
    defaultLanguage,
    filters,
  };
};

export default connect(mapStateToProps)(DonorsFilter);
